import { render, staticRenderFns } from "./ServiceSettings.vue?vue&type=template&id=2801cd04&scoped=true"
import script from "./ServiceSettings.vue?vue&type=script&lang=js"
export * from "./ServiceSettings.vue?vue&type=script&lang=js"
import style0 from "./ServiceSettings.vue?vue&type=style&index=0&id=2801cd04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2801cd04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2801cd04')) {
      api.createRecord('2801cd04', component.options)
    } else {
      api.reload('2801cd04', component.options)
    }
    module.hot.accept("./ServiceSettings.vue?vue&type=template&id=2801cd04&scoped=true", function () {
      api.rerender('2801cd04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ServiceSettings.vue"
export default component.exports